export const globalActionTypes = {
	SWITCH_VIEW: "SWITCH_VIEW",
	SET_STEP: "SET_STEP",
	NEXT_STEP: "NEXT_STEP",
	PREV_STEP: "PREV_STEP",
	SET_LOADER_ACTIVE: "SET_LOADER_ACTIVE",
	SET_LOADER_INACTIVE: "SET_LOADER_INACTIVE"
};
